export default function ProgressRing({ value = 0, total = 1, size = 64, stroke = 6, label }) {
  const pct = total > 0 ? Math.min(1, value / total) : 0;
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const offset = c * (1 - pct);

  return (
    <div className="inline-flex items-center justify-center relative" data-testid="progress-ring">
      <svg width={size} height={size} className="block">
        <circle cx={size/2} cy={size/2} r={r} stroke="#E0F2FE" strokeWidth={stroke} fill="none" />
        <circle
          cx={size/2}
          cy={size/2}
          r={r}
          stroke="#38BDF8"
          strokeWidth={stroke}
          fill="none"
          strokeLinecap="round"
          strokeDasharray={c}
          strokeDashoffset={offset}
          transform={`rotate(-90 ${size/2} ${size/2})`}
          style={{ transition: "stroke-dashoffset 0.5s ease" }}
        />
      </svg>
      <div className="absolute inset-0 flex items-center justify-center text-xs font-bold text-sky-700 font-display">
        {label ?? `${value}/${total}`}
      </div>
    </div>
  );
}
